import { render, staticRenderFns } from "./BranchName.vue?vue&type=template&id=77c8d368&scoped=true&"
import script from "./BranchName.vue?vue&type=script&lang=js&"
export * from "./BranchName.vue?vue&type=script&lang=js&"
import style0 from "./BranchName.vue?vue&type=style&index=0&id=77c8d368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c8d368",
  null
  
)

export default component.exports